// src/pages/NotFound.jsx
import { Link } from "react-router-dom";
import Layout from "../../components/Layout";

export default function NotFound() {
  return (
    <Layout>
    <div style={styles.container}>
      <h1 style={styles.code}>404</h1>
      <p style={styles.message}>Oops! The page you are looking for doesn't exist.</p>
    </div>
    </Layout>
  );
}

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    backgroundColor: "#f8f9fa",
    textAlign: "center",
    padding: "20px",
  },
  code: {
    fontSize: "96px",
    fontWeight: "bold",
    color: "#343a40",
  },
  message: {
    fontSize: "24px",
    color: "#6c757d",
    marginBottom: "20px",
  },
  link: {
    padding: "10px 20px",
    backgroundColor: "#007bff",
    color: "#fff",
    textDecoration: "none",
    borderRadius: "5px",
  },
};
